export default {"src":"/_next/static/media/customer-service.03707248.svg","height":48,"width":47,"blurWidth":0,"blurHeight":0};